// extracted by mini-css-extract-plugin
export default {"customTextara":"custom-text-area_customTextara__fJWU5","disableInput":"custom-text-area_disableInput__HeUBb"};